"use client"

import { useOnlineStatus } from "@/hooks/use-online-status"
import { useLocale } from "@/lib/locale-context"
import { WifiOff } from "lucide-react"

export function OfflineIndicator() {
  const isOnline = useOnlineStatus()
  const { locale } = useLocale()

  if (isOnline) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 animate-fade-in">
      <div className="flex items-center gap-2 px-4 py-2 bg-amber-500 text-white rounded-full shadow-lg">
        <WifiOff className="h-4 w-4" />
        <span className="text-sm font-medium">
          {locale === "es" ? "Sin conexión" : "You're offline"}
        </span>
      </div>
    </div>
  )
}
